const NoCommitment = ({ width = 30, height = 30 }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path id="a" d="M0 0h29.93v29.93H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <g mask="url(#b)" fill="#2A3135" fillRule="nonzero">
        <path d="M22.448 11.224V7.483A7.483 7.483 0 0014.965 0a7.483 7.483 0 00-7.183 5.378.935.935 0 00.935 1.17.935.935 0 00.936-.646 5.612 5.612 0 0110.924 1.58v3.742H1.871v15.9a2.806 2.806 0 002.806 2.807h20.577a2.806 2.806 0 002.806-2.806V11.224h-5.612zm3.741 15.9a.935.935 0 01-.935.936H4.677a.935.935 0 01-.936-.935v-14.03H26.19v14.03z" />
      </g>
    </g>
  </svg>
);

export default NoCommitment;
